import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-flag-nl",
  "use": "icon-flag-nl-usage",
  "viewBox": "0 0 1541 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1541 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-flag-nl\"><defs><style type=\"text/css\"></style></defs><path d=\"M6.308563 1017.710074h1520.904177V6.289926H6.308563v1011.420148z m1523.420148 3.773955v-3.773955 3.773955z m-1529.710074 2.515971V0h1533.484029v1024H0.018637z\" fill=\"#353636\" p-id=\"17405\" /><path d=\"M2.534607 681.82801h1527.194104v339.656019H2.534607z\" fill=\"#005D9B\" p-id=\"17406\" /><path d=\"M2.534607 342.17199h1527.194104v339.65602H2.534607z\" fill=\"#FFFFFF\" p-id=\"17407\" /><path d=\"M2.534607 2.515971h1527.194104v339.656019H2.534607z\" fill=\"#AF2A3A\" p-id=\"17408\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag-nl.svg
// module id = YWUD
// module chunks = 24